import { AppDispatch } from "../../redux/store";
import { Control } from "react-hook-form";
import { StylesConfig } from "react-select";

export const OTISRecords = {
  DC: "Distribution Channel/Name",
  Organizations: "Organization Name/ID",
  account_name: "Account Name/ID",
  initOrd: "INITIAL ORDERS",
  ltdUnits: "LTD\nORDERS",
  sales_notes: "Sales Notes",
  pub_goal: "Laydown Goal",
  currEst: "Laydown Estimate",
  // Force 3-line header and keep "(incl Laydown)" together on the 3rd line
  suppEst: "6-month\nEstimate\n(incl\u00A0Laydown)",
  compInit: "COMP_TITLE INITIAL ORDER",
  compGross: "COMP_TITLE GROSS SALES",
  compNet: "COMP_TITLE NET SALES",
  retPercentage: "COMP_TITLE % RETURNS (TBD)",
  cpos4wkPOS: "COMP_TITLE 4wk POS (TBD)",
  cpos8wkPOS: "COMP_TITLE 8wk POS (TBD)",
  Cpos_LTD: "COMP_TITLE LTD POS (TBD)",
};

export const HIDDEN_GRID_COLUMNS = [
  "retPercentage",
  "cpos4wkPOS",
  "cpos8wkPOS",
] as const;

// types.ts or interfaces.ts

export interface Organization {
  _id: string;
  orgName: string;
  org_sales_notes?: string;
  accounts: Account[];
}
export interface Account {
  accountNumber: string;
  accountName?: string;
  units?: string | number;
  ltdUnits?: string | number;
  compInit?: { $numberDecimal?: string } | string | number;
  compGross?: { $numberDecimal?: string } | string | number;
  compNet?: { $numberDecimal?: string } | string | number;
  pub_goal?: { $numberDecimal?: string } | string | number;
  currEst?: { $numberDecimal?: string } | string | number;
  printmtdDate?: { $numberDecimal?: string } | string | number;
  suppEst?: { $numberDecimal?: string } | string | number;
  sales_notes?: string;
  retPercentage?: { $numberDecimal?: string } | string | number;
  cpos4wkPOS?: { $numberDecimal?: string } | string | number;
  cpos8wkPOS?: { $numberDecimal?: string } | string | number;
  Cpos_LTD?: { $numberDecimal?: string } | string | number;
}

export interface Organization {
  _id: string;
  organizationId: string; // Merged from the second definition
  orgName: string;
  org_sales_notes?: string;
  accounts: Account[];
    accountName: string;
  accountNumber:string;
  units: number;

}

export interface RecordType {
  main_supplemental_estimate: string;
  main_print_meeting_date: string;
  main_current_estimate: string;
  main_pubgoal: string;
  main_sales_notes?: string;
  _id: string;
  DISTRIBUTION_CHANNEL: any; // Consider replacing `any` with a specific type
  DISTRIBUTION_CHANNEL_NAME: any; // Consider replacing `any` with a specific type
  isNew: boolean;
  organizations?: Organization[]; // Make optional to match usage
}

export interface TableRowProps {
  record: RecordType;
  index: number;
  formData: { [key: string]: any };
  setFormData: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>; // Add setFormData
  handleFieldChange: (
    recordId: string,
    orgId: string,
    accountId: string,
    field: string,
    value: any,
    orgName?: string | null,
    accountName?: string | null
  ) => void;
  selectKey: number;
  repCodeSearchOptions: any[];
  organizationSearchOptions: any[];
  accountSearchOptions: any[];
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  currentPage: number;
  setCurrentPage: (value: number) => void;
  selectedRepIDS: any;
  selectedOrgIDs: any;
  selectedAccountIDs: any;
  fetchCustomerAccounts: (
    searchTerm?: string,
    repCode?: string,
    orgId?: string,
    accountId?: string,
    page?: number,
    dispatch?: AppDispatch

  ) => void;
  dispatch: AppDispatch;
  setSelectedRepId: (value: any) => void;
  setSelectedOrgId: (value: any) => void;
  setSelectedAccountId: (value: any) => void;
  repcodeRef: React.RefObject<any>;
  OrgRef: React.RefObject<any>;
  selectRef: React.RefObject<any>;
  setGrandTotal: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  tableRef: React.RefObject<any>;
  setModal:boolean;
  shouldClear:boolean;
  
}




export const getInputClassName = (field: string) => {
  let baseClass =
    "py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";

  if (field === "sales_notes") {
    return `${baseClass} w-[200px] mx-2`;
  } else if (field === "compInit") {
    return `${baseClass} bg-gray-100 cursor-not-allowed w-[85%]`;
  }

  return `${baseClass} w-[85%]`;
};


export const selectStyles:StylesConfig<any, false> = {    container: (provided: any) => ({
    ...provided,
    pointerEvents: "auto",
  }),
  input: (provided: any) => ({
    ...provided,
    position: "absolute",
    pointerEvents: "auto",
    left: 6,
    marginRight: "10px",
    caretColor: "auto",
  }),
    option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected || state.isFocused ? "#E6E6E6" : "",
    color: state.isSelected ? "black" : "black",
  }),
  multiValue: (provided: any) => ({
    ...provided,
    height: "30px",
    display: "flex",
    alignItems: "center",
    borderRadius: "6px",
    minWidth: "none",
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 1050,
    position: "absolute" as const,
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 1050,
  }),
 valueContainer: (provided: any) => ({
    position: "relative",
    maxWidth: "28vw",
    width: "100%",
    paddingLeft: "6px",
    display: "flex",
    alignItems: "center",
    height: "40px",
    paddingRight: "8px",
    overflowX: "auto",
    overflowY: "hidden",
    minWidth: "50px",
    boxSizing: "border-box",
    //   ...(isFirefox && {
    //     maxWidth: "calc(28vw + 10px)",
    //     scrollbarWidth: "thin",
    //   }),
  }),
 control: (provided: any) => ({
    display: "flex",
    // maxWidth:"37vw",
    // width:"510px",
    height: "40px",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth:"180px"
  }), 
 menuList: (provided: any) => ({
    maxHeight: "100px",
    overflow: "hidden",
    overflowY: "auto",
  }),
    clearIndicator: () => ({
     marginLeft: "1px",
    marginTop: "5px",
    color: "gray",
    cursor: "pointer",
  }),
};

export const selectClassName =
  "mt-2 border border-solid border-neutral-300 font-poppins rounded-lg w-full font-normal lg:text-[12px] overflow-x-auto max-w-[200px] sm:text-[10px] text-left";


/* ------------------------------------------------------------------
 * SEG Rollups ("super channels")
 *
 * Source: SEG map and channel remapping project.xlsx,
 *         tab "NEW SEG proposal apr 2026".
 *
 * Maps DISTRIBUTION_CHANNEL code -> rollup name. Channels not listed
 * fall into UNASSIGNED_ROLLUP so nothing is silently dropped.
 *
 * NOTE: some codes carry two DISTRIBUTION_CHANNEL_NAME values in
 * BigQuery (RETINDEP is both "Independent" and "Indie Bookstores";
 * SMIND is both "SpecMkt Indy" and "Special Markets Independents").
 * This map keys on code only, so both variants land in the same
 * rollup. Confirm with Phil whether that is intended.
 * ------------------------------------------------------------------ */

export const UNASSIGNED_ROLLUP = "Unassigned";

export const CHANNEL_TO_ROLLUP: Record<string, string> = {
  ONLRET: "Online Retail",
  NATCHAIN: "Bookstore Chains",
  MASSMER: "Mass Merch",

  RETINDEP: "Trade Independents",
  MUSEUM: "Trade Independents",

  DISTRADE: "Trade Distributors",

  SMIND: "Special Markets",
  SPWHOL: "Special Markets",
  SMCHAIN: "Special Markets",
  SMMUSEUM: "Special Markets",
  UKEMEA: "International",
  COMICSTR: "Special Markets",
  AUTHCON: "Special Markets",

  EDULIB: "Educational And Library Sales",
  BOOKCLUB: "Book Clubs",

  AMCA: "Canada",
  INDG: "Canada",
  CANEDULI: "Canada",
  CANINDIE: "Canada",

  "INTL AB": "International",
  ANZ: "International",
};

/** Display order in the grid. Anything unlisted sorts to the end. */
export const ROLLUP_ORDER: string[] = [
  "Online Retail",
  "Bookstore Chains",
  "Mass Merch",
  "Trade Independents",
  "Trade Distributors",
  "Special Markets",
  "Educational And Library Sales",
  "Book Clubs",
  "Canada",
  "International",
  "Other",
  UNASSIGNED_ROLLUP,
];

export const getRollupForChannel = (channelCode?: string | null): string => {
  if (!channelCode) return UNASSIGNED_ROLLUP;
  return CHANNEL_TO_ROLLUP[channelCode.trim()] ?? UNASSIGNED_ROLLUP;
};

export const compareRollups = (a: string, b: string): number => {
  const ia = ROLLUP_ORDER.indexOf(a);
  const ib = ROLLUP_ORDER.indexOf(b);
  return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
};